import './container.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Container = forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={classNames({
      container: true,
      [className]: className,
    })}
    {...props}
  >
    {children}
  </div>
));

Container.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Container;
